import { MouseEvent, useEffect, useState } from 'react';
import { ContentBlock } from '../../../../lib/types/aemDataModels';
import styles from './Accordion.module.scss';
import { PlusIcon } from '../../../../lib/icons/PlusIcon';
import ContentBlockView from '../../../common/ContentBlockView/ContentBlockView';
import { MinusIcon } from '../../../../lib/icons/MinusIcon';

export type AccordionItemProps = {
  item: ContentBlock;
  onOpen: (block?: ContentBlock) => void;
  selection?: ContentBlock;
  singleItemExpansion?: boolean;
};

const Accordion = ({ item, onOpen, selection, singleItemExpansion }: AccordionItemProps) => {
  const [expanded, setExpanded] = useState(false);

  const itemClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (expanded) {
      onOpen(undefined);
      setExpanded(false);
    } else {
      onOpen(item);
    }
  };

  useEffect(() => {
    if (singleItemExpansion) {
      setExpanded(item === selection);
    } else {
      setExpanded(current => current || item === selection);
    }
  }, [selection, item, singleItemExpansion]);

  return (
    <div key={item.heading} className={styles.item}>
      <h3 className={styles.headingContainer}>
        <button onClick={itemClick} className={styles.button} aria-expanded={expanded}>
          <span className={styles.heading}>{item.heading}</span>
          {expanded ? <MinusIcon className={styles.icon} /> : <PlusIcon className={styles.icon} />}
        </button>
      </h3>
      <div className={styles.itemContent} hidden={!expanded}>
        <ContentBlockView headingHidden contentBlock={item} />
      </div>
    </div>
  );
};

export default Accordion;
